import Repository from '../axios'

const  resource = "/landlord/permissions";
export default {
  get() {
    return Repository.get(`/user/permissions`)
  },
};
